import { useTranslation } from "react-i18next";
import "../../../i18n";
import { useDocumentEvents } from "../../../api/queries";
import { EventsBody } from "./bodies/EventsBody";

export { sortEvents } from "./bodies/EventsBody";

export function EventsPanel({ docId, title }: { docId: string; title?: string }) {
  const { t } = useTranslation();
  const events = useDocumentEvents(docId);
  const heading = title ?? t("documents.inspector.events.title", "Events");

  return (
    <section className="card">
      <div className="card-head">
        <h2 className="grow">{heading}</h2>
      </div>
      <div className="card-body">
        <EventsBody events={events.data} isError={events.isError} />
      </div>
    </section>
  );
}
